import React from 'react';
import { Link } from 'react-router-dom';

const Section = ({ title, children }) => (
  <div style={{ marginBottom: '2rem' }}>
    <h2 style={{ fontSize: '1.2rem', fontWeight: '700', color: '#1a365d', marginBottom: '0.75rem', borderBottom: '2px solid #bee3f8', paddingBottom: '0.4rem' }}>{title}</h2>
    <div style={{ color: '#4a5568', lineHeight: '1.8', fontSize: '0.97rem' }}>{children}</div>
  </div>
);

const SubHeading = ({ children }) => (
  <h3 style={{ fontSize: '1rem', fontWeight: '700', color: '#2d3748', marginTop: '1.25rem', marginBottom: '0.5rem' }}>{children}</h3>
);

const li = { marginBottom: '0.4rem' };
const ul = { paddingLeft: '1.5rem', marginBottom: '0.75rem' };

const PointTable = ({ head, rows, totalLabel, totalValue }) => (
  <div style={{ overflowX: 'auto', marginBottom: '0.75rem' }}>
    <table style={{ width: '100%', minWidth: '360px', borderCollapse: 'collapse', fontSize: '0.92rem' }}>
      <thead>
        <tr>
          {head.map((h, i) => (
            <th key={i} style={{
              textAlign: i === head.length - 1 ? 'center' : 'left',
              padding: '0.6rem 0.9rem', backgroundColor: '#f7fafc', color: '#1a365d',
              fontWeight: '700', borderBottom: '2px solid #e2e8f0',
            }}>{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={i} style={i % 2 === 1 ? { backgroundColor: '#fafbfc' } : undefined}>
            {r.map((c, j) => (
              <td key={j} style={{
                textAlign: j === r.length - 1 ? 'center' : 'left',
                padding: '0.55rem 0.9rem', borderBottom: '1px solid #edf2f7', color: '#4a5568',
                fontWeight: j === r.length - 1 ? '700' : '400',
              }}>{c}</td>
            ))}
          </tr>
        ))}
        {totalLabel && (
          <tr>
            <td colSpan={head.length - 1} style={{ padding: '0.6rem 0.9rem', fontWeight: '700', color: '#1a365d', borderTop: '2px solid #e2e8f0' }}>{totalLabel}</td>
            <td style={{ textAlign: 'center', padding: '0.6rem 0.9rem', fontWeight: '800', color: '#1a365d', borderTop: '2px solid #e2e8f0' }}>{totalValue}</td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

const RatingMethodology = () => (
  <div style={{ minHeight: '100vh', backgroundColor: '#f7fafc', padding: '2rem 1rem' }}>
    <div style={{ maxWidth: '860px', margin: '0 auto', backgroundColor: 'white', borderRadius: '16px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', padding: '2.5rem' }}>
      <div style={{ marginBottom: '2rem' }}>
        <Link to="/" style={{ color: '#3182ce', fontSize: '0.9rem', textDecoration: 'none' }}>← Бош саҳифа</Link>
        <h1 style={{ fontSize: '1.8rem', fontWeight: '800', color: '#1a365d', marginTop: '1rem', marginBottom: '0.5rem' }}>
          AdvokatTop рейтинг тизими методологияси
        </h1>
        <p style={{ color: '#718096', fontSize: '0.9rem' }}>ATR-100 — адвокатларнинг касбий рейтингини ҳисоблаш тартиби</p>
      </div>

      <Section title="1. Умумий қоидалар">
        <p style={{ marginBottom: '0.6rem' }}>1.1. Ушбу методология AdvokatTop.uz ахборот платформасида Ўзбекистон Республикаси адвокатларининг касбий рейтингини ҳисоблаш тартибини белгилайди.</p>
        <p style={{ marginBottom: '0.6rem' }}>1.2. Рейтинг адвокатларнинг касбий маҳорати, амалий тажрибаси, хизмат сифати, касбий обрўси ва бошқа объектив кўрсаткичларни баҳолаш мақсадида шакллантирилади.</p>
        <p style={{ marginBottom: '0.6rem' }}>1.3. Рейтинг адвокатнинг касбий фаолияти тўғрисида жамоатчилик учун очиқ маълумот беришга хизмат қилади.</p>
        <p>1.4. Рейтинг суд қарорларига таъсир кўрсатиш ёки давлат органлари қарорлари учун мажбурий ҳужжат ҳисобланмайди.</p>
      </Section>

      <Section title="2. Методологиянинг мақсади">
        <p style={{ marginBottom: '0.5rem' }}>Методологиянинг асосий мақсадлари:</p>
        <ul style={ul}>
          <li style={li}>аҳолига адвокат танлашда ёрдам бериш;</li>
          <li style={li}>ҳуқуқий хизматлар бозори шаффофлигини ошириш;</li>
          <li style={li}>касбий рақобатни ривожлантириш;</li>
          <li style={li}>хизмат сифати ошишига рағбатлантириш;</li>
          <li style={li}>адвокатлар ҳақида ишончли маълумотларни жамлаш.</li>
        </ul>
      </Section>

      <Section title="3. Асосий принциплар">
        <p style={{ marginBottom: '0.5rem' }}>Рейтинг қуйидаги принципларга асосланади:</p>
        <ul style={ul}>
          <li style={li}><strong>Объективлик</strong> — фақат текширилган маълумотлар ҳисобга олинади.</li>
          <li style={li}><strong>Шаффофлик</strong> — баҳолаш формуласи очиқ эълон қилинади.</li>
          <li style={li}><strong>Тенглик</strong> — барча адвокатлар учун ягона мезонлар қўлланилади.</li>
          <li style={li}><strong>Ҳолислик</strong> — тўланган реклама ёки пуллик хизматлар рейтингга таъсир қилмайди.</li>
          <li style={li}><strong>Текшириш имконияти</strong> — ҳар бир балл тасдиқланган манбага эга бўлади.</li>
          <li style={li}><strong>Даврийлик</strong> — рейтинг мунтазам равишда қайта ҳисобланади.</li>
        </ul>
      </Section>

      <Section title="4. ATR-100 рейтинг тизими">
        <PointTable
          head={['№', 'Кўрсаткич', 'Максимал балл']}
          rows={[
            ['1', 'Касбий малака', '20'],
            ['2', 'Амалий тажриба', '25'],
            ['3', 'Мижозлар қониқиши', '20'],
            ['4', 'Касбий обрў', '15'],
            ['5', 'Очиқлик ва рақамли фаоллик', '10'],
            ['6', 'Илмий ва ижтимоий фаолият', '5'],
            ['7', 'Тасдиқланган ишонч индекси', '5'],
          ]}
          totalLabel="Жами"
          totalValue="100 балл"
        />
      </Section>

      <Section title="5. Баҳолаш мезонлари">
        <SubHeading>5.1. Касбий малака (20 балл)</SubHeading>
        <p style={{ fontWeight: '600', marginBottom: '0.4rem' }}>Адвокатлик стажи</p>
        <PointTable
          head={['Стаж', 'Балл']}
          rows={[
            ['1–3 йил', '3'], ['3–5 йил', '5'], ['5–10 йил', '8'],
            ['10–15 йил', '10'], ['15–20 йил', '12'], ['20 йилдан юқори', '15'],
          ]}
        />
        <p style={{ fontWeight: '600', marginBottom: '0.4rem' }}>Малака ошириш</p>
        <ul style={ul}>
          <li style={li}>республика курслари – 1 балл</li>
          <li style={li}>халқаро курслар – 2 балл</li>
          <li style={li}>малака сертификатлари – 3 балл</li>
        </ul>
        <p style={{ marginBottom: '0.75rem' }}>Максимум – 3 балл.</p>
        <p style={{ fontWeight: '600', marginBottom: '0.4rem' }}>Чет тиллари</p>
        <ul style={ul}>
          <li style={li}>инглиз</li>
          <li style={li}>рус</li>
          <li style={li}>бошқа тиллар</li>
        </ul>
        <p>Максимум – 2 балл.</p>

        <SubHeading>5.2. Амалий тажриба (25 балл)</SubHeading>
        <p style={{ fontWeight: '600', marginBottom: '0.4rem' }}>Тасдиқланган ишлар</p>
        <PointTable
          head={['Ишлар сони', 'Балл']}
          rows={[
            ['30 гача', '3'], ['30–100', '6'], ['100–300', '10'],
            ['300–700', '15'], ['700 дан юқори', '18'],
          ]}
        />
        <p style={{ marginBottom: '0.6rem' }}><strong>Ихтисослашув</strong> — бир ёки бир нечта ҳуқуқ соҳасида чуқур ихтисослашув – 4 балл.</p>
        <p><strong>Мураккаб ишлар</strong> — апелляция, кассация, халқаро арбитраж, йирик иқтисодий низолар ва бошқа юқори мураккабликдаги ишлар – 3 балл.</p>

        <SubHeading>5.3. Мижозлар қониқиши (20 балл)</SubHeading>
        <p style={{ marginBottom: '0.5rem' }}>Фақат тасдиқланган мижозлар баҳоси қабул қилинади. Баҳолаш мезонлари:</p>
        <ul style={ul}>
          <li style={li}>хизмат сифати;</li>
          <li style={li}>мулоқот маданияти;</li>
          <li style={li}>тушунтириш қобилияти;</li>
          <li style={li}>муддатларга риоя қилиш;</li>
          <li style={li}>умумий қониқиш.</li>
        </ul>
        <p>Ҳар бири – 4 балл.</p>

        <SubHeading>5.4. Касбий обрў (15 балл)</SubHeading>
        <PointTable
          head={['Кўрсаткич', 'Балл']}
          rows={[
            ['Интизомий жазолар мавжуд эмас', '5'],
            ['Касбий этикага риоя', '4'],
            ['Ҳамкасблар баҳоси', '3'],
            ['Касбий тавсиялар', '3'],
          ]}
        />

        <SubHeading>5.5. Очиқлик ва рақамли фаоллик (10 балл)</SubHeading>
        <PointTable
          head={['Кўрсаткич', 'Балл']}
          rows={[
            ['Фото', '1'], ['Лицензия', '2'], ['Офис маълумотлари', '1'],
            ['Иш вақти', '1'], ['Мақолалар', '2'], ['Видеодарслар', '1'], ['Онлайн маслаҳат', '2'],
          ]}
        />

        <SubHeading>5.6. Илмий ва ижтимоий фаолият (5 балл)</SubHeading>
        <ul style={ul}>
          <li style={li}>китоблар;</li>
          <li style={li}>илмий мақолалар;</li>
          <li style={li}>конференциялар;</li>
          <li style={li}>ҳуқуқий тарғибот ишлари.</li>
        </ul>

        <SubHeading>5.7. Ишонч индекси (5 балл)</SubHeading>
        <PointTable
          head={['Кўрсаткич', 'Балл']}
          rows={[
            ['Шахс тасдиқланган', '1'],
            ['Лицензия текширилган', '1'],
            ['Телефон тасдиқланган', '1'],
            ['Офис тасдиқланган', '1'],
            ['Тасдиқланган мижозлар мавжуд', '1'],
          ]}
        />
      </Section>

      <Section title="6. Якуний формула">
        <div style={{
          backgroundColor: '#ebf5ff', border: '1px solid #bee3f8', borderRadius: '10px',
          padding: '1rem 1.25rem', textAlign: 'center', fontSize: '1.15rem', fontWeight: '800',
          color: '#1a365d', letterSpacing: '0.03em', marginBottom: '1rem',
        }}>
          ATR = Q + E + C + R + D + S + T
        </div>
        <p style={{ marginBottom: '0.5rem' }}>Бу ерда:</p>
        <ul style={ul}>
          <li style={li}><strong>Q</strong> – касбий малака;</li>
          <li style={li}><strong>E</strong> – амалий тажриба;</li>
          <li style={li}><strong>C</strong> – мижозлар қониқиши;</li>
          <li style={li}><strong>R</strong> – касбий обрў;</li>
          <li style={li}><strong>D</strong> – рақамли фаоллиқ;</li>
          <li style={li}><strong>S</strong> – илмий фаолият;</li>
          <li style={li}><strong>T</strong> – ишонч индекси.</li>
        </ul>
        <p>Максимал рейтинг — 100 балл.</p>
      </Section>

      <Section title="7. Маълумотлар манбалари">
        <p style={{ marginBottom: '0.5rem' }}>Рейтинг қуйидаги манбалар асосида шакллантирилади:</p>
        <ul style={ul}>
          <li style={li}>адвокат тақдим этган ҳужжатлар;</li>
          <li style={li}>давлат реестрлари;</li>
          <li style={li}>лицензия маълумотлари;</li>
          <li style={li}>суд қарорлари ҳақидаги очиқ маълумотлар (қонунчилик доирасида);</li>
          <li style={li}>тасдиқланган мижоз фикрлари;</li>
          <li style={li}>оммавий ахборот воситаларидаги расмий маълумотлар;</li>
          <li style={li}>AdvokatTop.uz томонидан ўтказилган текширув натижалари.</li>
        </ul>
      </Section>

      <Section title="8. Рейтингни янгилаш">
        <p style={{ marginBottom: '0.5rem' }}>Рейтинг:</p>
        <ul style={ul}>
          <li style={li}>ҳар ой автоматик ҳисобланади;</li>
          <li style={li}>ҳар чоракда қайта кўриб чиқилади;</li>
          <li style={li}>ҳар йил якуний рейтинг эълон қилинади.</li>
        </ul>
      </Section>

      <Section title="9. Эътироз билдириш тартиби">
        <p style={{ marginBottom: '0.5rem' }}>Адвокат:</p>
        <ul style={ul}>
          <li style={li}>рейтинг натижалари билан танишиш;</li>
          <li style={li}>қўшимча ҳужжатлар тақдим этиш;</li>
          <li style={li}>маълумотларни тузатишни сўраш;</li>
          <li style={li}>рейтингни қайта ҳисоблашни талаб қилиш ҳуқуқига эга.</li>
        </ul>
        <p>Эътироз 15 иш куни ичида кўриб чиқилади.</p>
      </Section>

      <Section title="10. Якуний қоидалар">
        <p style={{ marginBottom: '0.6rem' }}>Ушбу методология AdvokatTop.uz миллий рейтинги учун асосий меъёрий ҳужжат ҳисобланади.</p>
        <p>Методологияга киритиладиган ўзгартишлар AdvokatTop.uz таҳририяти томонидан эълон қилинади.</p>
      </Section>

      <Section title="Рейтинг даражалари">
        <PointTable
          head={['Балл', 'Даража']}
          rows={[
            ['96–100', 'Аъло'],
            ['91–95', 'Зўр'],
            ['81–90', 'Жуда яхши'],
            ['71–80', 'Яхши'],
            ['61–70', 'Ўртача'],
            ['60 дан паст', 'Эҳтиёткорлик'],
          ]}
        />
      </Section>

      <div style={{ textAlign: 'center', margin: '2rem 0' }}>
        <Link to="/attorney/rating-submission" style={{
          display: 'inline-block', backgroundColor: '#FFD700', color: '#0d1f17',
          fontWeight: '700', padding: '0.85rem 1.75rem', borderRadius: '10px', textDecoration: 'none',
        }}>
          Рейтинг учун ариза топшириш →
        </Link>
      </div>

      <p style={{ color: '#a0aec0', fontSize: '0.8rem', textAlign: 'center', borderTop: '1px solid #edf2f7', paddingTop: '1.25rem' }}>
        © AdvokatTop.uz. Ушбу методология AdvokatTop.uz платформасининг интеллектуал мулки ҳисобланади. Методологиядан тижорат мақсадида фойдаланиш AdvokatTop.uz рухсатисиз тақиқланади.
      </p>
    </div>
  </div>
);

export default RatingMethodology;
